import {autoinject, bindable} from 'aurelia-framework';
import {Dispatch} from "../services/dispatch";

@autoinject()
export class RevealCustomAttribute {

    @bindable({primaryProperty: true}) tag: string;
    @bindable class: string = 'reveal';

    constructor(private element: Element,
                private dispatch: Dispatch) {}

    bind() {
        this.dispatch.registerListener(this.tag, this);
    }

    public onChange(state: string) {
        if (state) {
            this.element.classList.add(this.class);
        } else {
            this.element.classList.remove(this.class);
        }


    }


}
